import { FormControl, FormGroupDirective, NgForm, FormGroup, AbstractControl, ValidationErrors } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class CotErrorStateMatcher implements ErrorStateMatcher {
    private _touchedActivated: boolean = false;
    constructor(touchedActivated: boolean = false) {
        this._touchedActivated = touchedActivated;
    }

    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        ////const isSubmitted = form && form.submitted;
        ////return (control && (control.invalid || control.value == undefined || control.value == null || control.value == "" || control.value == "-1"));
        //let hasError: boolean = false;
        //if (control && control.enabled) {
        //    if (control.invalid) {
        //        hasError = true;
        //    }
        //    else {
        //        if (hasRequiredValidator(control) && (!control.value)) {
        //            hasError = true;
        //        }
        //        //if (hasCheckedValidator(control) && (!control.value)) {
        //        //    hasError = true;
        //        //}
        //    }
        //}
        //return hasError;
        let hasError: boolean = false;
        if (!this._touchedActivated) {
            if (control && control.enabled) {
                if (control.invalid)
                    hasError = true;
                else {
                    if (hasRequiredValidator(control) && (!control.value))
                        hasError = true;
                }
            }
        }
        else {
            if (control && control.enable && control.touched) {
                if (control.invalid)
                    hasError = true;
                else {
                    if (hasRequiredValidator(control) && !control.value)
                        hasError;
                }
            }
        }
        return hasError;
    }
}

// hasRequiredValidator
const hasRequiredValidator = (abstractControl: AbstractControl): boolean => {
    if (abstractControl.validator) {
        const errors: ValidationErrors = abstractControl.validator({} as AbstractControl);
        if (errors && errors.required) {
            return true;
        }
    }
    if (abstractControl['controls']) {
        for (const controlName in abstractControl['controls']){
            if (abstractControl['controls'][controlName]) {
                if (hasRequiredValidator(abstractControl['controls'][controlName])) {
                    return true;
                }
            }
        }
    }
    return false;
}





// WEBPACK FOOTER //
// ./src/app/services/cot-error-state-matcher.ts